import type { LanguageOption } from './types';

export interface LanguageOptionConfig {
  value: LanguageOption;
  nameKey: 'english' | 'spanish' | 'french';
}

export const LANGUAGE_OPTIONS: readonly LanguageOptionConfig[] = [
  { value: 'en', nameKey: 'english' },
  { value: 'es', nameKey: 'spanish' },
  { value: 'fr', nameKey: 'french' },
] as const;
